import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
@Injectable({
  providedIn: 'root'
})
export class ApiHelper {

    domain: string = `${environment.serverProtocol}${environment.serverDomain}`;

    constructor(
        private readonly http: HttpClient,
    ) { }

    get(path: string, query?: any, domain: string = this.domain, opts?: any) {
        let params = {
            params: query
        }
        if(opts) {
            params = {
                ...params,
                ...opts
            }
        }

        return this.http.get(domain + path, params)
    }

    post(path: string, payload: any, domain: string = this.domain) {
        return this.http.post(domain + path, payload)
    }

    put(path: string, payload: any = {}, domain: string = this.domain) {
        return this.http.put(domain + path, payload)
    }

    delete(path: string, domain: string = this.domain) {
        return this.http.delete(domain + path)
    }
}